import { gql } from '@/__generated__';

export const USE_TIME_RANGE_ON_TRIGGER_RETRY_DGA_REPORTS = gql(`#graphql
  query GetAccessUseTimeRangeOnTriggerRetryDGAReports {
    authorization {
      authorizationGeneral {
        useTimeRangeOnTriggerRetryDGAReports
      }
    }
  }
`);

